export default __webpack_public_path__ + "static/media/Image_news_dashboard_es.5278d4e5.png";